var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgChildren = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M28.3334 11.6667C30.6346 11.6667 32.5001 9.8012 32.5001 7.50001C32.5001 5.19882 30.6346 3.33334 28.3334 3.33334C26.0322 3.33334 24.1667 5.19882 24.1667 7.50001C24.1667 9.8012 26.0322 11.6667 28.3334 11.6667Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 26.6667H23.3333C23.3333 26.9767 23.3333 33.0233 23.3333 33.3333C23.3333 34.2533 24.0799 35 24.9999 35C25.9199 35 26.6666 34.2533 26.6666 33.3333C26.6666 33.0233 26.6666 26.9767 26.6666 26.6667Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 26.6667H30C30 26.9767 30 33.0233 30 33.3333C30 34.2533 30.7467 35 31.6667 35C32.5867 35 33.3333 34.2533 33.3333 33.3333C33.3333 33.0233 33.3333 26.9767 33.3333 26.6667Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 13.3333H26.6667C23.9051 13.3333 21.6667 15.5717 21.6667 18.3333V24.1667C21.6667 25.2533 22.3651 26.1683 23.3334 26.5133V21.6667H33.3334V26.5133C34.3017 26.1683 35.0001 25.2533 35.0001 24.1667V18.3333C35.0001 15.5717 32.7617 13.3333 30.0001 13.3333Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M23.3333 21.6667V26.6667H26.6666C26.6666 25.7467 27.4133 25 28.3333 25C29.2533 25 29.9999 25.7467 29.9999 26.6667H33.3333V21.6667H23.3333Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.6667 11.6667C13.9679 11.6667 15.8333 9.8012 15.8333 7.50001C15.8333 5.19882 13.9679 3.33334 11.6667 3.33334C9.36548 3.33334 7.5 5.19882 7.5 7.50001C7.5 9.8012 9.36548 11.6667 11.6667 11.6667Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 28.3333H6.66675C6.66675 28.6433 6.66675 33.0233 6.66675 33.3333C6.66675 34.2533 7.41341 35 8.33341 35C9.25341 35 10.0001 34.2533 10.0001 33.3333C10.0001 33.0233 10.0001 28.6433 10.0001 28.3333Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 28.3333H13.3333C13.3333 28.6433 13.3333 33.0233 13.3333 33.3333C13.3333 34.2533 14.0799 35 14.9999 35C15.9199 35 16.6666 34.2533 16.6666 33.3333C16.6666 33.0233 16.6666 28.6433 16.6666 28.3333Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M18.2717 26.2233L17.0133 21.6667H6.32L5.06167 26.2233C4.76834 27.285 5.56667 28.3333 6.66834 28.3333H16.6667C17.7667 28.3333 18.565 27.285 18.2717 26.2233Z",
    fill: "currentColor"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.9066 11.5733C20.3407 11.1391 19.9883 10.0828 19.1193 9.21392C18.2504 8.34502 17.1941 7.99258 16.7599 8.42672C16.3258 8.86086 16.6783 9.91718 17.5472 10.7861C18.4161 11.655 19.4725 12.0074 19.9066 11.5733Z",
    fill: "currentColor"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M5.78607 10.7861C6.65497 9.91713 7.00742 8.86079 6.57328 8.42667C6.13914 7.99254 5.08281 8.34502 4.21391 9.21395C3.34501 10.0829 2.99257 11.1392 3.42671 11.5733C3.86085 12.0075 4.91717 11.655 5.78607 10.7861Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.3333H10.8333C7.61167 13.3333 5 15.945 5 19.1667V22.5C5 23.1317 5.25333 23.6867 5.64 24.125L6.32 21.6667H17.0133L17.6917 24.125C18.08 23.6867 18.3333 23.1317 18.3333 22.5V19.1667C18.3333 15.945 15.7217 13.3333 12.5 13.3333Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChildren, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/children.bef4618e.svg";
export { ForwardRef as ReactComponent };